<div class="logo">
  <a [routerLink]="[getHomePath()]" class="logo-mini">
    <div class="logo-img">
      <img [src]="logoUrl" />
    </div>
  </a>
  <!-- <a href="#" class="simple-text logo-normal ">
        Skylark Control
    </a> -->
</div>
<div class="sidebar-wrapper">
<work-order-search-field *ngIf="role === 5 || role === 4"></work-order-search-field>
  <ul class="nav">
    <li routerLinkActive="active" *ngFor="let menuItem of menuItems" class="{{menuItem.class}} nav-item">
      <a [routerLink]="[menuItem.path]">
        <i class="{{menuItem.icon}}"></i>
        <p class="d-inline-flex align-items-center">{{menuItem.title}}
          <span
              *ngIf="menuItem.badge"
              class="badge badge-pill"
              [ngClass]="[menuItem.badge.className]"
              [ngbTooltip]="menuItem.badge.tooltip ? menuItem.badge.tooltip : null"
              placement="right"
          >{{ menuItem.badge.text }}</span>
        </p>
      </a>

      <div class="subnav-wrapper" *ngIf="menuItem.children.length">
        <ul class="subnav">
          <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngFor="let child of menuItem.children" class="nav-item">
            <a [routerLink]="[child.path]">
              <p>{{child.title}}</p>
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
